import { getKeycloakURL } from "@utils/Common";

export const env = {
  get keycloakUrl(): string {
    return `https://${getKeycloakURL()}/`;
  },
  get keycloakRealm(): string {
    return process.env.REACT_APP_KEYCLOAK_REALM ?? "";
  },
  get keycloakClientId(): string {
    return process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? "";
  },
  /**
   * Base origin used for check-sso / login callbacks.
   * Local: override via REACT_APP_KEYCLOAK_LOGIN_REDIRECT_URL (e.g. http://localhost:3000).
   * Deployed: falls back to window.location.origin.
   */
  get keycloakLoginRedirectUrl(): string {
    const configured =
      process.env.REACT_APP_KEYCLOAK_LOGIN_REDIRECT_URL?.replace(/\/$/, "");
    if (configured) return configured;
    if (typeof window !== "undefined") return window.location.origin;
    return "";
  }
};

/**
 * Whether the Keycloak Bearer token flow is enabled.
 * - localhost: enabled by default; set REACT_APP_KEYCLOAK_LOCAL=false to disable.
 * - deployed: enabled when realm and clientId are set via env vars.
 */
export function isKeycloakEnabled(): boolean {
  if (typeof window === "undefined") return false;
  return Boolean(env.keycloakRealm && env.keycloakClientId);
}
